const PRELOAD_ERROR_RELOAD_KEY = 'vite-preload-error-reloaded';

type PreloadErrorStorage = Pick<Storage, 'getItem' | 'setItem'>;

interface HandlePreloadErrorParams {
  event: Event;
  storage: PreloadErrorStorage;
  reload: () => void;
}

export function handlePreloadError({
  event,
  storage,
  reload,
}: HandlePreloadErrorParams): void {
  try {
    if (storage.getItem(PRELOAD_ERROR_RELOAD_KEY)) {
      return;
    }

    storage.setItem(PRELOAD_ERROR_RELOAD_KEY, 'true');
  } catch {
    return;
  }

  event.preventDefault();
  reload();
}

export function registerPreloadErrorHandler(): void {
  window.addEventListener('vite:preloadError', (event) => {
    let storage: Storage;
    try {
      storage = window.sessionStorage;
    } catch {
      return;
    }

    handlePreloadError({
      event,
      storage,
      reload: () => window.location.reload(),
    });
  });
}
